import { useQuery } from '@apollo/client';
import { Unit, gql } from 'graphql-query-contracts';

const fetchPropertySuites = gql(/* GraphQL */ `
  query ListUnits($propertyId: UUID!) {
    property(propertyId: $propertyId) {
      units {
        id
        name
        description
        floors {
          id
          index
          name
        }
      }
    }
  }
`);

export const useFetchPropertySuites = (propertyId: string) => {
  const { loading, error, data } = useQuery(fetchPropertySuites, {
    variables: { propertyId },
    skip: !propertyId,
  });

  const suites =
    data?.property?.units?.filter(
      (unit): unit is Unit => !!unit && !!unit.id
    ) || [];

  return {
    loading,
    suites,
    error,
  };
};
